export default "__VITE_ASSET__cb6fcfeb__"